import React from 'react';
import { H3 } from '@osmosis/tailwind-ui/components/Text';
import { LoggedOutProductLibraryContainsItem } from '../../../types/library';
import LibraryL3PageLoggedOut from '../LibraryL3PageLoggedOut';
import LibraryL3PageNoContainsLoggedOut from '../LibraryL3PageNoContainsLoggedOut';
import LibraryL3LevelLoggedOut from '../LibraryL3LevelLoggedOut';
import ScrollToElement from '@osmosis/nextjs-components/ScrollToElement';

type Props = {
  l1: LoggedOutProductLibraryContainsItem;
  l2: LoggedOutProductLibraryContainsItem;
  l3: LoggedOutProductLibraryContainsItem;
  targetId?: string;
};

/**
 * L3Item.
 */
const L3Item = ({ l1, l2, l3, targetId }: Props) => {
  const elementId = encodeURI(`${l1.id}-${l2.id}-${l3.id}-L3`);
  const isTargetElement = targetId === elementId;
  if (l3.contains) {
    const type = l3.contains[0]?.type;
    if (type === 'level') {
      return (
        <LibraryL3LevelLoggedOut
          l3={l3}
          l1Id={l1.id}
          l2Id={l2.id}
          key={l3.name + l3.type + l3.id}
          {...(targetId && { targetId })}
        />
      );
    } else if (type === 'page') {
      return (
        <React.Fragment key={l3.name}>
          {isTargetElement && <ScrollToElement elementId={elementId} />}
          <H3
            data-id={l3.name + l3.type}
            cn="ml-8 mr-8 pt-8 pb-2 border-b-1 border-slate-200"
            data-testid="library-topic-box-l3-level"
            id={elementId}
          >
            {l3.displayName || l3.name}
          </H3>

          <LibraryL3PageLoggedOut l3={l3} />
        </React.Fragment>
      );
    }
  }

  return <LibraryL3PageNoContainsLoggedOut key={l3.name + l3.type} l3={l3} />;
};

export default L3Item;
